export var RadioButtonGroupLayout;
(function (RadioButtonGroupLayout) {
    RadioButtonGroupLayout["Horizontal"] = "horizontal";
    RadioButtonGroupLayout["Vertical"] = "vertical";
})(RadioButtonGroupLayout || (RadioButtonGroupLayout = {}));
//# sourceMappingURL=types.js.map